import * as React from 'react';
import { Field, InjectedFormProps, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { getText } from '../../../../../services/text/text-service';
import HelpBox from '../../../../components/HelpBox/HelpBox';
import { Title } from '@gje/typography/lib';
import { ageResolver } from '../../../../../services/customer/customer-service';
import { isMobile } from 'react-device-detect';
import { MileageValues } from '../../../../../types/enums/products/companyCar/details';
import useMobileOrTablet from '../../../../../hooks/useMobileOrTablet';

interface DetailsPanelProps {
    mileageChangeHandling: Function;
}

interface StateToProps {
    firstCalculationData: any;
    templateData: any;
}

class DetailsPanel extends React.Component<
    InjectedFormProps & DetailsPanelProps & StateToProps
> {
    componentDidMount() {
        window.addEventListener('resize', this.resize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    resize = () => this.forceUpdate();

    state = {
        age: ageResolver(
            this.props.firstCalculationData.calculatedData.calculation.cpr
        )
    };

    resolveDefaultValue(options) {
        let defaultOption = options.find(o => o.default === true);
        if (defaultOption) {
            return defaultOption.value;
        } else {
            return '';
        }
    }

    renderDropdown = ({ input, data }) => {
        return (
            <div className="col-sm-9 no-padding">
                <div className="form-group input-medium">
                    <label
                        htmlFor={input.name}
                        className="text-left input-label">
                        {data.label}
                    </label>
                    <div className="flex align align-items">
                        <select
                            children={this.renderOptions(data.options)}
                            id={input.name}
                            name={input.name}
                            onChange={e => data.onChange(e, input.onChange)}
                            className="form-control min-height-53 dropdown-border"
                            defaultValue={this.mileageData.default}
                        />
                        <HelpBox
                            helpText={data.helpText}
                            id={input.name + 'helpBox'}
                            place={useMobileOrTablet() ? 'left' : null}
                        />
                    </div>
                </div>
            </div>
        );
    };

    renderOptions = options => {
        return options.map((option, index) => {
            return (
                <option
                    key={index}
                    value={option.value}
                    children={option.name}
                />
            );
        });
    };

    renderMileage = () => {
        return this.props.templateData.yearlyKm
            .map(mileage => ({
                name: mileage.name,
                value: mileage.value
            }))
            .filter(mileage => mileage.value in MileageValues);
    };

    mileageData = {
        label: getText('webshopsweden.products.car.mileage'),
        helpText: getText('webshopsweden.products.car.mileage.helpText'),
        options: this.renderMileage(),
        onChange: this.props.mileageChangeHandling,
        default: this.resolveDefaultValue(this.props.templateData.yearlyKm)
    };

    render() {
        return (
            <form
                className={
                    window.innerWidth <= 921 || isMobile
                        ? 'row details-panel mobile-padding'
                        : 'row details-panel'
                }>
                <div
                    className={
                        window.innerWidth <= 921 || isMobile ? '' : 'col-sm-1-5'
                    }
                />
                <div
                    className={
                        window.innerWidth <= 921 || isMobile
                            ? 'col-sm-23'
                            : 'col-sm-20'
                    }>
                    <Title tag="h3" className="text-left">
                        {getText('webshopsweden.common.moreDetailsHeader')}
                    </Title>
                    <div className="row margin-top-13">
                        <Field
                            name="yearlyKm"
                            data={this.mileageData}
                            component={this.renderDropdown}
                        />
                    </div>
                </div>
                <div
                    className={
                        window.innerWidth <= 921 || isMobile ? '' : 'col-sm-1-5'
                    }
                />
            </form>
        );
    }
}

const mapStateToProps = state => ({
    detailsPanelForm: state.form.detailsPanel,
    firstCalculationData: state.calculationData,
    templateData: state.templateData.templateData
});

const Connected = connect(mapStateToProps, {})(DetailsPanel);

export default reduxForm<DetailsPanelProps, any>({
    form: 'detailsPanel',
    destroyOnUnmount: false
})(Connected);
